import React, { useEffect, useState } from 'react'

import TaxRates from './TaxRates';
import TaxCalculation from './TaxCalculation';

const TaxReport = ({setTax}) => {
	const [loading, setLoading] = useState(true);
	const [viewTax, setViewTax] = useState("");
	const [taxrates, setTaxRates] = useState(false);
	const [taxCal, setTaxCal] = useState(false);

	useEffect(() => {
		setLoading(false);
	}, []);

	useEffect(() => {
		setViewTax(setTax);
	}, [setTax]);

	useEffect(() => {
		viewTax === "taxrates" ? setTaxRates(true) : setTaxRates(false);
		viewTax === "taxcalculation"
			? setTaxCal(true)
			: setTaxCal(false);
	}, [viewTax]);
  return (
    <>
			<div className="content container-fluid">
				<div value={viewTax} className="pt-1">
				</div>
				<div className="body py-2">
					<div className="col-md-12">
						{taxrates && <TaxRates />}
						{taxCal && <TaxCalculation />}
					</div>
				</div>
			</div>
		</>
  )
}

export default TaxReport